import * as C from '../constants'

export const resetGame = () => ({
  type: C.RESET_GAME
})

export const startGame = () => ({
  type: C.START_GAME
})

export const startLevel = (level) => ({
  type: C.START_LEVEL,
  payload: {
    level
  }
})

export const checkChar = (char) => ({
  type: C.CHECK_CHAR,
  payload: {
    index: char,
  }
})

export const finalAnswer = (char) => ({
  type: C.FINAL_ANSWER
})
